@if (summary; as summary) {
<p class="forecast-note">
  @if (summary.level) {
  <span class="quality" [ngClass]="summary.level" [matTooltip]="qualityHint">
    <span class="dot"></span>{{ 'prediction.quality_' + summary.level | translate }}
  </span>
  }

  @if (!compact) {
  @for (model of summary.models; track model) {
  <span class="model">{{ 'prediction.model_' + model | translate }}</span>
  }
  }

  @for (reason of summary.reasons; track reason) {
  <span>{{ 'prediction.reason_' + reason | translate }}</span>
  }

  @if (!compact && summary.outliers) {
  <span>{{ 'editor.forecast_outliers' | translate: { count: summary.outliers } }}</span>
  }

  @if (!compact && summary.capped) {
  <span>{{ 'prediction.capped' | translate }}</span>
  }
</p>
}
